import { PageHero } from '@/components/ui/PageHero'
import { kandakePortrait } from '@/assets/siteMedia'

export const ContactHero = () => (
  <PageHero
    image={kandakePortrait}
    imageAlt="Kandake Makonnen smiling at a table with herbs and herbal medicine books"
    highlights={['Kandake replies personally', 'Enquire by email', 'Call-back to book']}
    title="Get in"
    accent="touch."
    description={
      <p>
        Book a consultation, ask a question, or enquire about any service. Kandake personally
        responds to every message.
      </p>
    }
  />
)
